import { Injectable } from '@angular/core';

import { ProductCategory, RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ProductCategoriesService } from '../product-categories.service';
import { ProductCategoriesActions } from './product-categories.actions';
import { StopsActions } from '../../stops';
import { NgRedux } from '@angular-redux/store';

@Injectable({
    providedIn: 'root'
})
export class ProductCategoriesEpics implements RidangoEpic {
    constructor(
        private actions: ProductCategoriesActions,
        private service: ProductCategoriesService,
        private ngRedux: NgRedux<any>,
        private stopsActions: StopsActions
    ) {}

    register() {
        return [this.fetchAllProductCategories];
    }

    fetchAllProductCategories = (action$: ActionsObservable<any>) =>
        action$.ofType(ProductCategoriesActions.FETCH_PRODUCT_CATEGORIES).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchProductCategoriesRequest().pipe(
                    map((response: ProductCategory[]) => {
                        const groups = response.filter((i) => i.extra_information?.zones);
                        if (groups.length) {
                            const defaultGroup = groups.find((i) => i.extra_information.isDefault);
                            this.ngRedux.dispatch(this.stopsActions.setGroups(groups));
                            this.ngRedux.dispatch(this.stopsActions.setDefaultGroup(defaultGroup));
                        }

                        // transform payload to state-acceptable
                        // normalizing for state id: object
                        const normalized = response.reduce((acc, val) => {
                            return { ...acc, [val.id]: val };
                        }, {});

                        // getting unique array of types
                        const uniqueTypes = response
                            .sort((a, b) => {
                                return a.type_order > b.type_order ? 1 : -1;
                            })
                            .filter((c, index, self) => {
                                return (
                                    index ===
                                    self.findIndex((t) => {
                                        return t.type === c.type;
                                    })
                                );
                            })
                            .map((category) => category.type);

                        const sortedByCategoryOrder = response.sort((a, b) => {
                            return a.order > b.order ? 1 : -1;
                        });

                        // setting ids based on available category types
                        const categoryIdsByType = uniqueTypes.reduce((acc, val) => {
                            return {
                                ...acc,
                                [val]: sortedByCategoryOrder.filter((c) => c.type === val).map((c) => c.id)
                            };
                        }, {});
                        // setting up state object
                        const stateObject = {
                            byId: normalized,
                            allIds: sortedByCategoryOrder.map((c) => c.id),
                            types: uniqueTypes,
                            categoryIdsByType: categoryIdsByType
                        };
                        return this.actions.fetchProductCategoriesSuccess(stateObject);
                    }),
                    catchError((error) => of(this.actions.fetchProductCategoriesFailed(error)))
                );
            })
        );
}
